import type { FeedbackPayload, ContactFormValues } from './types';

export const ContactFormMapper = {
  toFeedbackPayload(values: ContactFormValues): FeedbackPayload {
    const fullName = `${values.first_name} ${values.last_name}`.trim();
    return {
      email: values.email.trim(),
      phone: (values.phone ?? '').trim(),
      title: fullName,
      description: values.message.trim(),
    };
  },
};
